export default __webpack_public_path__ + "static/media/random.529d3842.gif";